// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import AvailableReward from './AvailableReward'
import ExpiredReward from './ExpiredReward'
import PaidList from './PaidList';
import { getRewardInsideList, getExpiredList, getPaidList, storeQRCode } from '../action';

// #endregion

class TabList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      availableLoading:true,
      expiredLoading:true,
      paidLoading:true,
      activeTab: 0,
    }
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uid !== this.props.uid) {
      this.setState({
        availableLoading: true,
        expiredLoading: true,
        paidLoading: true,
      });
      this.getData();
    }
  }

  getData(){
    const { getRewardInsideList, getExpiredList, getPaidList, uid } = this.props;
    if (typeof getRewardInsideList !== 'function' || typeof getExpiredList !== 'function' || typeof getPaidList !== 'function') {
      this.setState({
        availableLoading: false,
        expiredLoading: false,
        paidLoading: false,
      });
      return;
    }
    if (uid == null || String(uid).trim() === '') {
      this.setState({
        availableLoading: false,
        expiredLoading: false,
        paidLoading: false,
      });
      return;
    }
    const finishAvailable = () => this.setState({ availableLoading: false });
    const finishExpired = () => this.setState({ expiredLoading: false });
    const finishPaid = () => this.setState({ paidLoading: false });

    const p0 = getRewardInsideList(uid, 0);
    if (p0 != null && typeof p0.then === 'function') {
      p0.then(finishAvailable).catch(finishAvailable);
    } else {
      finishAvailable();
    }
    const p1 = getExpiredList(uid, 1);
    if (p1 != null && typeof p1.then === 'function') {
      p1.then(finishExpired).catch(finishExpired);
    } else {
      finishExpired();
    }
    const p2 = getPaidList(uid, 2);
    if (p2 != null && typeof p2.then === 'function') {
      p2.then(finishPaid).catch(finishPaid);
    } else {
      finishPaid();
    }
  }
  onTabChange(activeTab){
    this.setState({ activeTab });
  }
  render() {
    const tabs = ["Available", "History","Paid"];
    const { activeTab } = this.state;
    const tabListStyle: any = {
      display: 'flex',
      borderBottom: '1px solid #d5d5d5',
      marginBottom: '8px',
    };
    const tabStyle: any = {
      flex: 1,
      background: 'transparent',
      border: 'none',
      borderBottom: '2px solid transparent',
      padding: '10px 8px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#525252',
      cursor: 'pointer',
      outline: 'none',
    };
    const activeTabStyle: any = {
      borderBottom: '2px solid var(--primaryBlue)',
      color: 'var(--primaryBlue)',
      fontWeight: 600,
    };

    return (
      <React.Fragment>
        <div className="reward-tabs" role="tablist" aria-label="Reward tabs" style={tabListStyle}>
          {tabs.map((tab, index) => (
            <button
              key={tab}
              type="button"
              role="tab"
              aria-selected={activeTab === index}
              className={activeTab === index ? 'rmd-tab rmd-tab--active' : 'rmd-tab'}
              style={activeTab === index ? { ...tabStyle, ...activeTabStyle } : tabStyle}
              onClick={() => this.onTabChange(index)}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeTab === 0 ? (
          <AvailableReward 
            availableRewardList={this.props.availableRewardList} 
            isLoading={this.state.availableLoading}
            storeQRCode={this.props.storeQRCode}
            uid={this.props.uid}
          />
        ) : null}

        {activeTab === 1 ? (
          <ExpiredReward 
            expiredRewardList={this.props.expiredRewardList} 
            isLoading={this.state.expiredLoading}
          />
        ) : null}

        {activeTab === 2 ? (
          <PaidList 
            paidList={this.props.paidList} 
            isLoading={this.state.paidLoading}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
// #endregion
const mapStateToProps = state => {
  return {
    availableRewardList:state.reward.availableRewardList,
    expiredRewardList:state.reward.expiredRewardList,
    paidList:state.reward.paidList
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRewardInsideList,
      getExpiredList,
      getPaidList,
      storeQRCode,
    },
    dispatch
  );

// #endregion
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(TabList);